import {useTranslation} from '@/translations/i18n.tsx'
import {FC} from 'react'
import {
    ASSIGNMENT_DESCRIPTION_TEXT_CLASSNAME,
    ASSIGNMENT_DESCRIPTION_TITLE_CLASSNAME,
    ASSIGNMENT_DESCRIPTION_WRAPPER_CLASSNAME
} from '@features/assignment/constants'
import {CheckCircleIcon} from '@components/ui/icon'
import {cn} from '@utilities/helpers'

export const ReviewCompletedDescription: FC = () => {
    const {t} = useTranslation()

    return (
        <div className={ASSIGNMENT_DESCRIPTION_WRAPPER_CLASSNAME}>
            <div className={cn(ASSIGNMENT_DESCRIPTION_TEXT_CLASSNAME, 'gap-2.5')}>
                <CheckCircleIcon size={48} className="text-success-600" />
                <h3 className={ASSIGNMENT_DESCRIPTION_TITLE_CLASSNAME}>
                    {t('assignment:descriptions:review_completed:title')}
                </h3>
            </div>
        </div>
    )
}
